import { useMediaQuery } from 'react-responsive';

export default function useIsMobile(breakpoint = 600) {
  return useMediaQuery({ maxWidth: breakpoint });
}
